import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import ScrollAnimation from "react-animate-on-scroll";
import { FiCheck } from "react-icons/fi";
import SectionTitle from "../sectionTitle/SectionTitle";

const AboutFour = ({ image }) => {
  return (
    <div className="slider-area  height-850 bg_image" data-black-overlay="2">

      <div className="container">
      <div className="row">
                <div className="col-lg-12">
                  <SectionTitle
                    textAlign="text-center"
                    radiusRounded=""
                    subtitle="Método 2"
                    title="Gastromentoría"
                  />
                </div>
              </div>
        <div className="row row--30 align-items-center">
          <div className="col-lg-5">
            <div className="thumbnail">
              <img
                className="w-100"
                src="./dare/dan-05.png"
                alt="Dan Panini"
                loading="lazy"
              />
            </div>
          </div>

          <div className="col-lg-7 mt_md--30 mt_sm--30">

            <div className="content">

              <div className="section-title">


                <ScrollAnimation
                  animateIn="fadeInUp"
                  animateOut="fadeInOut"
                  animateOnce={true}
                >
                  <ul className="list-icon">
                    <li className="p3-white">
                      <span className="icon-check">
                        <FiCheck />
                      </span>{" "}
                      ¿Qué hacemos?
                    </li>
                    <li className="p3-white">
                      Es nuestro servicio de asesoramiento estratégico diseñado
                      para propietarios, gerentes generales y líderes en la
                      industria gastronómica. A través de sesiones de Coaching
                      semanales distribuidas en módulos de 3 meses (12 sesiones
                      en total), colaboramos contigo para identificar los
                      desafíos y metas, ayudándote a diseñar un plan de acción
                      claro y efectivo.
                    </li>
                    <li className="p3-white">
                      <span className="icon-check">
                        <FiCheck />
                      </span>{" "}
                      Cómo trabajamos:
                    </li>
                    <li className="p3-white">
                      En un enfoque abierto y colaborativo, exploramos
                      soluciones inmediatas y estrategias a mediano y largo
                      plazo para impulsar el rendimiento de tu negocio.
                      <br />
                      La GASTROMENTORÍA se centra en potenciar el liderazgo y
                      mejorar la eficiencia operativa, todo con miras al
                      crecimiento sostenible.
                    </li>
                    <li className="p3-white">
                      <span className="icon-check">
                        <FiCheck />
                      </span>{" "}
                      Nuestro compromiso:
                    </li>
                  
                  <li className="p3-white">
                    Ayudarte a llevar tu personal estratégico al siguiente
                    nivel.{" "}
                  </li>
                  </ul>
                </ScrollAnimation>
                <ScrollAnimation
                  animateIn="fadeInUp"
                  animateOut="fadeInOut"
                  animateOnce={true}
                >
                  <div className="read-more-btn mt--40">
                    <Link className="btn-default btn-icon" to="/contacto">
                      Contactanos{" "}
                      <i className="icon">
                        <FiArrowRight />
                      </i>
                    </Link>
                  </div>
                </ScrollAnimation>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutFour;
